export default "__VITE_ASSET__Ce1SpqJn__"